import { render, staticRenderFns } from "./UserActions.vue?vue&type=template&id=a5568306&scoped=true&"
import script from "./UserActions.vue?vue&type=script&lang=js&"
export * from "./UserActions.vue?vue&type=script&lang=js&"
import style0 from "./UserActions.vue?vue&type=style&index=0&id=a5568306&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5568306",
  null
  
)

export default component.exports